<template>
  <div>
    <!-- mobile menu -->
    <div v-if="isMobileDevice"
         class="ui compact menu mobile-menu">
      <a class="item"
         @click="openSignUpModal">
        <!--<i class="add user icon"></i>-->
        {{ trans.signUpMenu }}
      </a>
      <a class="item"
         @click="openLogInModal">
        <!--<i class="sign in icon"></i>-->
        {{ trans.logInMenu }}
      </a>
      <!--
      <a class="item" :href="googleLoginUrl">
        <i class="google plus icon"></i>
      </a>
      <a class="item" :href="facebookLoginUrl">
        <i class="facebook icon"></i>
      </a>
      -->
    </div>
    <!-- ./mobile menu -->
    <!-- desktop menu -->
    <div v-else>
      <div class="ui secondary menu">
        <menu-logo/>
        <div class="right menu">
          <button class="black-button"
                  data-v-desktop-logged-out-step="5"
                  @click="openSignUpModal">{{ trans.signUpMenu }}
          </button>
          <button class="black-button"
                  @click="openLogInModal">{{ trans.logInMenu }}
          </button>
          <!--
          <button class="social-button"  @click="facebookClick" data-push="false">
            <i class="facebook square icon"></i>
          </button>
          <button class="social-button" @click="googleClick" data-push="false">
            <i class="google plus g icon"></i>
          </button>
          -->
        </div>
      </div>
    </div>
    <!-- ./desktop menu -->
  </div>
</template>

<script>
import MenuLogo from './components/MenuLogo'
import notify from '../../notify'
import {mapState} from 'vuex'

export default {
  props: ['isMobileDevice', 'googleLoginUrl', 'facebookLoginUrl'],
  methods: {
    openSignUpModal () {
      /* eslint-disable */
      this.$modal.show('sign-up-modal')
    },
    openLogInModal () {
      this.$modal.show('log-in-modal')
    },
    facebookClick () {
      // location.href = this.facebookLoginUrl
      notify.info('Hamarosan...')
    },
    googleClick () {
      // location.href = this.googleLoginUrl
      notify.info('Hamarosan...')
    },

  },
  computed: {
    ...mapState({
      trans: state => state.trans.topMenu,
    }),
  },
  components: {
    MenuLogo,
  },
}
</script>

<style scoped>
.ui.menu {
  /* padding-bottom: .3rem; */
  /* padding-left: 1rem; */
  /* padding-top: .3rem; */
  /* width: 100%; */
  /* margin-bottom: 500px; */
  padding: 0.3rem 0 0.3rem 0;
  /* border-bottom: 1px solid rgba(34,36,38,.15); */
  color: white;
  position: fixed;
  top: 0;
  z-index: 99;
  left: 0;
  right: 0;
  height: 3rem;
  background: rgba(255, 156, 0, 0.8);
}

.ui.menu.mobile-menu {
  width: 100%;
  margin-bottom: 0.3rem !important;
  border-radius: 0;
  padding: 0;
  border: none;
  background: rgb(255, 156, 0);
  font-size: 150%;
}

.ui.menu:not(.vertical) .item {
  width: 50%;
  padding-left: 10%;
}

.social-buttons {
  margin-bottom: 0.3rem !important;
}

.ui.secondary.menu {
  padding-left: 10rem;
  padding-right: 10rem;
}

.menu-space-helper {
  content: ' ';
  height: 3.5rem;
}

.right.menu {
  padding: 0;
  background: #ffffff00;
}

.black-button {
  margin-right: 1rem;
  /*color: rgba(0,0,0,.87);*/
  color: white;
  font-weight: 300;
  letter-spacing: 0.2px;
  /*text-decoration: underline;*/
  font-family: 'Open Sans', sans-serif;
  font-size: 1rem;
  cursor: pointer;
}

.black-button:hover {
  text-decoration: none;
}

.black-button:focus {
  outline: 0;
}

/*
.button.google, .button.facebook {
  min-width: 9rem;
}
*/

.social-button {
  font-size: 1.8rem;
  color: white;
  opacity: 0.44;
  cursor: pointer;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
  -o-transition: all 0.5s;
  transition: all 0.5s;
}

.social-button:hover {
  color: #000;
}

.social-button:focus {
  outline: 0;
}
</style>
